<section
  class="py-7 py-md-0 bg-hero animate__animated animate__fadeIn"
  id="home"
>
  <!-- Capa de fondo anterior (queda debajo durante el crossfade) -->
  <div
    class="hero-bg"
    [style.background-image]="
      prevSection?.imageUrl ? 'url(' + prevSection?.imageUrl + ')' : ''
    "
  ></div>
  <!-- Capa de fondo actual (hace fade-in encima) -->
  <div
    class="hero-bg hero-bg--current"
    [class.hero-bg--fading-in]="isFading"
    (animationend)="onHeroFadeEnd($event)"
    [style.background-image]="
      currentSection?.imageUrl ? 'url(' + currentSection?.imageUrl + ')' : ''
    "
  ></div>
  <div class="hero-bg-overlay"></div>
  <div class="site-content">
    <div class="divisa-row vh-md-100">
      <div class="col-md-6 divisa-col-sm-12 col-12 my-auto px-0">
        <h1 class="heading-black mb-4 mb-md-0">
          {{ currentSection?.title || "El mejor tipo de cambio para tu viaje" }}
        </h1>
        <h2 class="hero-subheading mt-2 mb-0" *ngIf="currentSection?.subtitle">
          {{ currentSection?.subtitle }}
        </h2>
      </div>
      <div class="divisa-col-md-6 mx-auto my-md-auto mt-5">
        <div
          class="divisa-title align-items-center"
          *ngIf="tablaPrecios.length > 0"
        >
          <div class="col-2 col-lg-2"></div>
          <div class="col-2 col-lg-4 p-0">
            <strong>{{ 'LANDING.PRICE_TABLE.COLUMN_CURRENCY' | translate }}</strong>
          </div>
          <div class="col-4 col-lg-3">
            <strong>{{ 'LANDING.PRICE_TABLE.COLUMN_BUY' | translate }}</strong>
          </div>
          <div class="col-4 col-lg-3">
            <strong>{{ 'LANDING.PRICE_TABLE.COLUMN_SELL' | translate }}</strong>
          </div>
        </div>

        <div
          *ngFor="let divisa of tablaPrecios"
          class="divisa align-items-center my-3"
        >
          <div class="col-2 col-lg-2 align-items-center">
            <img
              class="img-icon-currency"
              src="{{ divisa.currency.logoUrl }}"
              alt="{{ divisa.currency.code | currencyName : divisa.currency.name }}"
            />
          </div>
          <div class="col-4 col-lg-4 p-0 truncate d-lg-block d-none">
            {{ divisa.currency.code | currencyName : divisa.currency.name }}
          </div>
          <div class="col-2 col-lg-4 p-0 truncate d-block d-lg-none">
            {{ divisa.currency.code | currencyName : divisa.currency.name }}
          </div>
          <div class="col-4 col-lg-3">
            <b>{{ divisa.buy | currency }}</b>
          </div>
          <div class="col-4 col-lg-3">
            <b>{{ divisa.sell | currency }}</b>
          </div>
        </div>

        <div class="exchange-date-label">
          <mat-icon class="exchange-date-icon" svgIcon="update"></mat-icon>
          <span>{{
            'LANDING.PRICE_TABLE.EXCHANGE_RATE_TODAY' | translate : { date: todayLabel }
          }}</span>
        </div>

        <div class="divisa-row mt-4 align-items-end">
          <div class="col-8 col-md-5 my-2 pr-2 ml-0">
            <fieldset>
              <legend>
                {{ 'LANDING.PRICE_TABLE.CHANGE_BRANCH_LEGEND' | translate }}
              </legend>
              <div class="form-group branch-selector-wrapper">
                <label for="branch-selector" class="branch-selector-label">
                  <select
                    id="branch-selector"
                    class="form-control branch-selector"
                    [(ngModel)]="sucursalId"
                    (change)="sucursalSeleccionada()"
                  >
                    <option
                      *ngFor="let sucursal of sucursales"
                      [value]="sucursal.id"
                    >
                      {{ sucursal.name }}
                    </option>
                  </select>
                  <em class="img-icon-divisas" data-feather="chevron-down"></em>
                </label>
              </div>
            </fieldset>
          </div>

          <div class="col-4 col-md-2 my-2 d-flex justify-content-center">
            <button
              mat-stroked-button
              [attr.aria-label]="'LANDING.PRICE_TABLE.MAP_ARIA_LABEL' | translate"
              class="button col-12 d-flex align-items-center justify-content-center btn-map-outline"
              (click)="scrollToMap()"
            >
              <mat-icon svgIcon="location_on"></mat-icon>
            </button>
          </div>

          <div class="col-12 col-md-5 my-2 pl-md-2 ml-0">
            <button
              mat-raised-button
              color="accent"
              [attr.aria-label]="'HOME_BRANCHES.RESERVE_BUTTON' | translate"
              class="button col-12"
              (click)="openDialog()"
              [disabled]="!(tablaPrecios.length > 0)"
            >
              {{ 'HOME_BRANCHES.RESERVE_BUTTON' | translate }}
              <mat-icon iconPositionEnd svgIcon="payments"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
